module.exports = __webpack_public_path__ + "static/media/Maf_Estereotipos_not.a08625c7.jpg";